import * as React from "react";
import { styled } from "@mui/system";
import MUITextareaAutosize from "@mui/material/TextareaAutosize";
import { TextareaAutosizeProps as TextareaAutosizePropsMUI } from "@mui/material/TextareaAutosize";
export interface TextareaAutosizeProps extends TextareaAutosizePropsMUI {}

export const TextareaAutosize: (props: TextareaAutosizeProps) => JSX.Element =
  styled(
    React.forwardRef<HTMLTextAreaElement, TextareaAutosizeProps>(
      (props, ref) => <MUITextareaAutosize ref={ref} {...props} />
    ),
    {
      name: "TextareaAutosize",
      slot: "Root",
      overridesResolver: (props, styles) => []
    }
  )(({ theme }) => ({
    ...theme.typography["body"],
    outline: "none",
    WebkitAppearance: "none",
    width: "-webkit-fill-available",
    // minHeight: 50,
    paddingLeft: 8,
    paddingTop: 10,
    paddingBottom: 10,
    paddingRight: 8,
    resize: "vertical",
    borderColor: theme.palette.primary.borderDefault,
    background: theme.palette.primary.inputBackgroundDefault,
    borderRadius: 0,
    ":hover": {
      borderColor: theme.palette.primary.borderActive
    },
    ":focus": {
      background: theme.palette.primary.inputBackgroundActive,
      borderColor: theme.palette.primary.borderActive
    },
    ":disabled": {
      cursor: "not-allowed !important",
      pointerEvents: "all !important",
      color: theme.palette.primary.textDisabledColor,
      borderColor: theme.palette.primary.borderDisabled,
      background: theme.palette.primary.inputBackgroundDisabledColor
    },
    ":read-only": {
      borderColor: theme.palette.primary.borderDisabled,
      background: theme.palette.primary.inputBackgroundDisabledColor
    },
    ":required": {
      borderColor: theme.palette.primary.borderError
    },
    ":placeholder": {
      color: theme.palette.primary.textDisabledColor
    }
  }));
